import { render, staticRenderFns } from "./communityServiceCenter.vue?vue&type=template&id=94818404&scoped=true"
import script from "./communityServiceCenter.vue?vue&type=script&lang=js"
export * from "./communityServiceCenter.vue?vue&type=script&lang=js"
import style0 from "./communityServiceCenter.vue?vue&type=style&index=0&id=94818404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94818404",
  null
  
)

export default component.exports